import { render, staticRenderFns } from "./TableProducts.vue?vue&type=template&id=4640e2d0"
import script from "./TableProducts.vue?vue&type=script&lang=js"
export * from "./TableProducts.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports